function contentThemeClassName(theme, state) {
  return theme ? `theme-${theme}-content${state ?? ""}` : void 0;
}
function controlsThemeClassName(theme, state) {
  return theme ? `theme-${theme}-controls${state ?? ""}` : void 0;
}
function themeClassName(theme, state) {
  return [
    contentThemeClassName(theme, state),
    controlsThemeClassName(theme, state)
  ];
}
export {
  contentThemeClassName,
  controlsThemeClassName,
  themeClassName
};
//# sourceMappingURL=themeClassName.js.map
